const smartTextAutoCompleteSelector = state => state.ui.smartTextAutoComplete;
export const isSmartTextAutoCompleteOpen = state =>
  smartTextAutoCompleteSelector(state).setAutoComplete;
